import { AccordionSummary } from "@mui/material";
import { styled } from "@mui/material/styles";
// Custom AccordionSummary component to restrict the height of the AccordionSummary component
// to a maximum of 48px, even when expanded. Used in the RecipeFilterModule component.
export const CustomAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
    maxHeight: theme.spacing(6),
    overflow: "hidden",
    backgroundColor: "transparent",
    "&.Mui-expanded": {
        minHeight: theme.spacing(6), // Ensures that even when expanded, the height is restricted
    },
}));
